import { Controller } from "@hotwired/stimulus";

// Typed-confirmation gate for a single model-assignment row (T-4.3, US-004,
// FR-024, Hiram HARD). Mirrors the app's existing type-to-confirm pattern
// (organization_delete_confirmation_controller.js), except the expected
// text is not a fixed token — it's the TARGET MODEL NAME the admin just
// selected (read live off the chosen <option>'s `data-model` attribute).
// Client-side only: the server (T-4.2's controller) re-validates the typed
// confirmation param independently.
export default class extends Controller {
  static targets = ["select", "confirmInput", "submitButton"];

  declare readonly selectTarget: HTMLSelectElement;
  declare readonly hasSelectTarget: boolean;
  declare readonly confirmInputTarget: HTMLInputElement;
  declare readonly hasConfirmInputTarget: boolean;
  declare readonly submitButtonTarget: HTMLButtonElement;
  declare readonly hasSubmitButtonTarget: boolean;

  connect() {
    this.disable();
    this.validate();
  }

  // Whenever the selection changes, any previously-typed confirmation no
  // longer matches the (new) target model — clear it and re-lock the
  // submit button rather than leaving a stale match enabled.
  changeModel() {
    if (this.hasConfirmInputTarget) this.confirmInputTarget.value = "";
    this.disable();
  }

  validate() {
    if (!this.hasSelectTarget || !this.hasConfirmInputTarget || !this.hasSubmitButtonTarget) return;

    const selectedOption = this.selectTarget.selectedOptions[0];
    const expected = selectedOption ? selectedOption.dataset.model : null;
    const enabled = !!expected && this.confirmInputTarget.value === expected;

    this.submitButtonTarget.disabled = !enabled;
  }

  disable() {
    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = true;
  }
}
